<div
  class="file-card"
  [class.is-image]="isFileImage"
  [ngStyle]="{
    'background-image': imageUrl ? 'url(' + imageUrl + ')' : 'none',
  }"
  (click)="fileService.openFile(file)">
  @if (isFileDocument) {
    <div class="document-icon">
      <img [src]="getDocumentIcon(file.type)" alt="{{ file.type }}" />
    </div>
    <div class="file-name">{{ file.name }}</div>
  }

  <button
    type="button"
    class="action-button circle-xsmall border-none"
    [disabled]="(loadingFileId$ | async) === file.id"
    [pTooltip]="(loadingFileId$ | async) === file.id ? 'Lädt...' : 'Aktionen'"
    [tooltipPosition]="'top'"
    (click)="fileMenu.show($event); $event.stopPropagation()">
    @if ((loadingFileId$ | async) === file.id) {
      <i class="fa-regular fa-spinner fa-spin circle-icon"></i>
    } @else {
      <i class="fa-regular fa-ellipsis-vertical circle-icon"></i>
    }
  </button>
</div>

<p-menu #fileMenu [model]="fileMenuItems" [popup]="true" appendTo="body">
  <ng-template pTemplate="item" let-item>
    <a pRipple class="flex align-items-center p-menu-item-link icon-24">
      <i [class]="item.icon"></i>
      <span class="ml-2">{{ item.label }}</span>
    </a>
  </ng-template>
</p-menu>
